<template>
  <div 
    v-if="visible"
    class="rounded-md bg-green-50 p-4"
  >
    <div class="flex">
      <div class="flex-shrink-0">
        <icon
          set="solid"
          name="check-circle"
          class="h-5 w-5 text-green-400"
        />
      </div>
      <div class="ml-3">
        <h3 class="text-sm leading-5 font-medium text-green-800">
          Discount successfully created
        </h3>
        <div class="mt-2 text-sm leading-5 text-green-700">
          <div 
            class="flex items-center space-x-2 text-sm leading-5 text-green-700"
          >
            <span>Discount Code:</span> 
            <span
              class="relative"
            >
              <span
                v-if="codeIsCopiedToClipboard"
                class="absolute inset-0 text-green-500 text-center bg-green-100"
              >
                Copied!
              </span>
              {{ code }}
            </span>
            <button
              type="button"
              class="focus:outline-none"
              v-if="canAccessClipboard"
              @click="copyToClipboard"
            >
              <icon
                :set="codeIsCopiedToClipboard ? 'solid' : 'outline'"
                name="document-duplicate"
                class="h-5 w-5"
              />
            </button>
          </div>
        </div>
      </div>
      <div class="ml-auto pl-3">
        <div class="-mx-1.5 -my-1.5">
          <button 
            type="button"
            class="inline-flex rounded-md p-1.5 text-green-500 hover:bg-green-100 focus:outline-none focus:bg-red-100 transition ease-in-out duration-150"
            aria-label="Dismiss"
            @click="visible = false"
          >
            <icon
              set="solid"
              name="x"
              class="h-5 w-5"
            />
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: "DiscountCreatd",
  props: {
    code: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      visible: true,
      canAccessClipboard: false,
      codeIsCopiedToClipboard: false,
    }
  },
  created() {
    navigator.permissions.query({name: "clipboard-write"})
      .then(result => this.canAccessClipboard = result.state === 'granted');
  },
  methods: {
    copyToClipboard() {
      navigator.clipboard.writeText(this.code)
        .then(() => this.highlightClipboard());
    },
    highlightClipboard() {
      this.codeIsCopiedToClipboard = true
      setTimeout(() => {
        this.codeIsCopiedToClipboard = false
      }, 1000);
    }
  }
};
</script>
